"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSilenceBackground = void 0;
const video_client_core_1 = require("@video/video-client-core");
/**
 * Contains media streams with silence audio background for preview.
 */
const previewStreams = new WeakMap();
/**
 * Replace the audio track with silence audio background and store in the previewStreams WeakMap.
 * If the stream is already in the WeakMap, return the stream from the WeakMap.
 */
function withSilenceBackground(audioCtx, mediaStream) {
    if (mediaStream == null) {
        return null;
    }
    const previewStream = previewStreams.get(mediaStream);
    if (previewStream != null) {
        return previewStream;
    }
    const videoTracks = mediaStream.getVideoTracks();
    if (videoTracks.length === 0) {
        return mediaStream;
    }
    const silentAudioStream = createSilencedBackground(audioCtx, videoTracks);
    previewStreams.set(mediaStream, silentAudioStream);
    return silentAudioStream;
}
exports.withSilenceBackground = withSilenceBackground;
/**
 * Connects our audioSourceNode to the audioCTX and sets its gain to be pretty much silent.
 */
function createSilencedBackground(audioCtx, videoTracks) {
    const audioTrack = video_client_core_1.utils.createSilentAudioTrack(audioCtx);
    // Check to ensure we have an audio track and the mediaStreamController has set it's videoTracks.\
    // Create our new MediaStream and set our newly created audioTrack and the mediaStreamController video track to it.
    const newStream = new MediaStream();
    videoTracks.forEach((vt) => {
        newStream.addTrack(vt);
        vt.addEventListener("ended", () => {
            audioTrack.stop();
        }, { once: true });
    });
    newStream.addTrack(audioTrack);
    return newStream;
}
//# sourceMappingURL=silence-background.js.map